import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ModelHubRoutes: RouteBundle = {
  domain: 'model-hub',
  routes: [
    {urlPattern: 'model-hub', handler: EditorRoutes.modelHub.bind(EditorRoutes), legacy: true},
    {urlPattern: 'model-hub/models', handler: EditorRoutes.modelHubModels.bind(EditorRoutes)},
    {urlPattern: 'model-hub/predictions', handler: EditorRoutes.modelHubPredictions.bind(EditorRoutes)},
    {
      urlPattern: 'model-hub/predictions/:id',
      handler: EditorRoutes.modelHubPredictionDetail.bind(EditorRoutes),
    },
    {urlPattern: 'model-hub/prediction-batches', handler: EditorRoutes.modelHubBatches.bind(EditorRoutes)},
    {
      urlPattern: 'model-hub/prediction-batches/:id',
      handler: EditorRoutes.modelHubBatchDetail.bind(EditorRoutes),
    },
    {urlPattern: 'model-hub/new-prediction', handler: EditorRoutes.modelHubNewPrediction.bind(EditorRoutes)},
  ],
};
